import React from "react";
import { Mail, Phone, MapPin, ExternalLink } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_cpsi-directory/artifacts/ckmcoulj_CPSI%20Logo.png" 
                alt="CPSI Logo"
                className="h-10 w-auto"
              />
              <div>
                <span className="font-heading font-bold text-lg">CPSI</span>
                <span className="text-xs text-slate-400 block">Member Portal</span>
              </div>
            </div>
            <p className="text-slate-400 text-sm">
              Clinical Psychology Society of India
            </p>
            <a 
              href="https://www.cpsindia.org.in" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-teal-400 text-sm hover:text-teal-300 transition-colors inline-flex items-center gap-1 mt-2"
            >
              Visit Main Website <ExternalLink className="w-3 h-3" />
            </a>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-semibold text-sm mb-3 text-slate-200">
              Contact
            </h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-teal-500 flex-shrink-0" />
                <a href="mailto:office@cpsindia.org.in" className="text-slate-400 text-sm hover:text-teal-400 transition-colors">
                  office@cpsindia.org.in
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-teal-500 flex-shrink-0" />
                <a href="tel:+919788722666" className="text-slate-400 text-sm hover:text-teal-400 transition-colors">
                  +91 9788722666
                </a>
              </li>
            </ul>
          </div>

          {/* Address */}
          <div>
            <h3 className="font-heading font-semibold text-sm mb-3 text-slate-200">
              Address
            </h3>
            <div className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-teal-500 mt-0.5 flex-shrink-0" />
              <span className="text-slate-400 text-sm">
                No.312, Z Cross, 3rd Block, HRBR Layout,<br />
                Kalyan Nagar, Bangalore - 560077
              </span>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-6 pt-4 border-t border-slate-800">
          <p className="text-slate-500 text-xs text-center">
            © {new Date().getFullYear()} CPSI. All rights reserved. | Registration # DRBI/SOR/96 2022-2023
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
